import { jsx as _jsx } from "react/jsx-runtime";
import Stack from '@mui/material/Stack';
import AccountDiscountCard from './components';
import { useMemo } from 'react';
import useCustomerReducer from '../useCustomerReducer';
const AccountDiscount = () => {
    const [{ customer }] = useCustomerReducer();
    const discountCategories = useMemo(() => { var _a; return ((_a = customer === null || customer === void 0 ? void 0 : customer.metaobjects) === null || _a === void 0 ? void 0 : _a.discountCategories) || []; }, [customer]);
    return (_jsx(Stack, Object.assign({ direction: 'row', gap: 2, flexWrap: 'wrap' }, { children: discountCategories.map((discountCategory) => (_jsx(AccountDiscountCard, { discountCategory: discountCategory }, discountCategory.id))) })));
};
export default AccountDiscount;
